import {  Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { 
  SharedDataService,
  SuppliersService,
  LoggedUserService,
  Supplier,
  Ps_LstPerimeters_XRP_Result ,
  DocumentsService,
  PS_Supplier_Purchase_Docs_Result,
  SimpleReponseResult,
  DocumentStatut,
  SupplierPurchaseComment,
  SuiviAchatsUpdateParameters,
  PS_PAFX_DR_Result
 } from 'ngx-paf-common';
import { forkJoin, Observable, of, Subscription, lastValueFrom } from 'rxjs';

import moment from 'moment';

import { finalize, tap } from 'rxjs/operators';
import { HttpEventType } from '@angular/common/http';

import { saveAs } from '@progress/kendo-file-saver';
import {  NgForm } from '@angular/forms';
import { PilotageEndelTabComponent } from '../pilotage-endel-tab/pilotage-endel-tab.component';
import { FinancesService } from 'localServices/finances.service';

@Component({
  selector: 'pilotage-suivi-achats',
  templateUrl: './pilotage-suivi-achats.component.html',
  styleUrls: ['./pilotage-suivi-achats.component.scss'],
  encapsulation:ViewEncapsulation.None  
})
export class PilotageSuiviAchatsComponent
extends PilotageEndelTabComponent 
implements OnInit, OnDestroy {

  reloadTab(): Promise<void> {
    this.loading = true;
    return lastValueFrom(
      forkJoin([
        this.documentsSvc.getDocumentStatuts(),
        this.reloadSupplier()
      ])
    ).then(([statuts, supplier]) => {
      this.lstDocStatuts = statuts;
      this.supplier = supplier;
      this.loading = false;
    }).catch(err => {
      this.loading = false;
      throw err;
    });
  }


  constructor(
    public sharedDataSvc:SharedDataService,
    private suppliersSvc:SuppliersService,
    private loggedUserSvc:LoggedUserService,
    private documentsSvc: DocumentsService,
    private financesSvc: FinancesService 
    ) { 
      super(sharedDataSvc);
    }

  ngOnDestroy(): void {
    if (this.intUserChangeSubscription) this.intUserChangeSubscription.unsubscribe();
  }

  ngOnInit(): void {   
    this.reloadTab().then(()=>{
        if (!this.sharedDataSvc.loggedIntUser) {
        this.intUserChangeSubscription=this.sharedDataSvc.loggedIntUserChange.subscribe(res=>this.loadPerimeters());
      } else {
        this.loadPerimeters();
      }   
    });
  }

  uploadProgress: number = null;
  uploadSub: Subscription;
  @ViewChild('fileContratCadreUpload') fileContratCadreUpload: ElementRef;
  @ViewChild('frmSuiviAchats') frmSuiviAchats: NgForm;

  suiviAchatsDatas:SuiviAchatsUpdateParameters= new SuiviAchatsUpdateParameters();
  suiviAchatsBkp?:SuiviAchatsUpdateParameters = null;

  userDrs:Ps_LstPerimeters_XRP_Result[]=[];
  allDrs:Ps_LstPerimeters_XRP_Result[]=[];
  supplierDocs:PS_Supplier_Purchase_Docs_Result[]=[];
  emptyComment:SupplierPurchaseComment=new SupplierPurchaseComment();
  get lstContratsCadre():PS_Supplier_Purchase_Docs_Result[] {
    return this.supplierDocs.filter(d=> d.Screen=='ENDEL/ACHATS_CTR' && d.RefDocId == this.suiviAchatsDatas.FrameworkContractPafDocId);
  }

 get lstContratsCadreForCods():PS_Supplier_Purchase_Docs_Result[] {
    return this.supplierDocs.filter(d=> d.Screen=='ENDEL/ACHATS_CTR' && d.DocId==0);
  }
 get lstDocsCom():PS_Supplier_Purchase_Docs_Result[] {
  return this.supplierDocs.filter(d=> d.Cod=='DOCUMENT_COMMERCIAL');
  }
  
  //lstDocsCom:PS_Supplier_Purchase_Docs_Result[]=[];
  lstDocStatuts:DocumentStatut[]=[];



  reloadSupplier():Observable<Supplier>{
    if (!this.supplierId) return of(null);
    return this.suppliersSvc.getSupplier(this.supplierId)
    .pipe(tap((supp:Supplier)=>{
      this.initemptyComment();
      this.suiviAchatsDatas= new SuiviAchatsUpdateParameters();
      this.suiviAchatsDatas.SupplierId=supp.Id;
      this.suiviAchatsDatas.TopConcurrent=false;//(supp.TopConcurrent ==1);
      this.suiviAchatsDatas.TopGroupement=(supp.TopGroupement ==1);
      this.suiviAchatsDatas.TopNational= false;//(supp.TopNational == 1);
      this.suiviAchatsDatas.DivSAPs=supp.SupplierPerimeters?.map(p=>p.DivSAP);
      this.suiviAchatsDatas.FrameworkContractDate = supp.FrameworkContractDate;
      this.suiviAchatsDatas.FrameworkContractPafDocId = supp.FrameworkContractPafDocId;
      this.suiviAchatsBkp=null;
      this.editMode = false;
      this.reloadDocs();
      this.frmSuiviAchats?.form.markAsPristine();
    }));
  }

  //private _selectedContratCadre?:PS_Supplier_Purchase_Docs_Result=null; 
  get selectedContratCadre():PS_Supplier_Purchase_Docs_Result | undefined{
    //return this._selectedContratCadre;
    let i:number= this.supplierDocs.findIndex(d=>d.Screen=='ENDEL/ACHATS_CTR' && !!d.FullPath);
    return (i>=0) ? this.supplierDocs[i]:undefined;
  }

  

  get lstPurchaseComments():SupplierPurchaseComment[]{
    return (this.supplier?.SupplierPurchaseComments || []).filter(c=>c.Screen=='pilotage/achats');
  }
  
  get unselectedPerimeters():Ps_LstPerimeters_XRP_Result[]{
    return this.allDrs.filter(p=>!this.suiviAchatsDatas.DivSAPs.some(sp=> sp==p.EtbXRP));
  }


  get selectedPerimeters():Ps_LstPerimeters_XRP_Result[]{
    return this.allDrs.filter(p=>this.suiviAchatsDatas.DivSAPs.some(sp=> sp==p.EtbXRP));
  }
  
  private _selectedPerimeter?: Ps_LstPerimeters_XRP_Result=null;
  get selectedPerimeter(): Ps_LstPerimeters_XRP_Result{
    return this._selectedPerimeter;
  }
  set selectedPerimeter(value:Ps_LstPerimeters_XRP_Result){
    this._selectedPerimeter = value;
    if (value){
      this.addPerimeter(value);
    }
  }
  intUserChangeSubscription?:Subscription;
  
  initemptyComment():void {
    this.emptyComment = new SupplierPurchaseComment();
    this.emptyComment.Screen='pilotage/achats';
    this.emptyComment.SupplierId = this.supplierId;
  }

  reloadDocs():void {
     this.documentsSvc.getSupplierPurchaseDocs(this.supplierId)
        .subscribe(res=>{
          res.forEach(d=>d.DocId = (d.DocId||0));
          res.sortObjectDesc('DocId');
          this.supplierDocs = res;
          this.supplierDocs.forEach(d=>{
            (<any>d).sortOrder = !d.DocId ? 9999999999: d.DocId;
          })
       });
  }


  loadPerimeters(): void {
    forkJoin([
      this.loggedUserSvc.LstPerimeters(),
      this.financesSvc.AllDrs(false)

    ])
      .subscribe({
        next: results => {
          this.userDrs = results[0];
          this.allDrs = results[1].map((dr: PS_PAFX_DR_Result) => {
            let item: Ps_LstPerimeters_XRP_Result = new Ps_LstPerimeters_XRP_Result();
            item.SocXRP = dr.SocCod;
            item.SocLib = dr.SocLib;
            item.EtbXRP = dr.EtbCod;
            item.EtbLib = dr.EtbLib;
            return item;
          });
        }
      });
  }
  get AccordCadreVal():string{
    if (!this.suiviAchatsDatas.FrameworkContractPafDocId){
      return 'Sans accord';
    } else {
      return 'Avec accord';
    }
  }

  



  addPerimeter(value:Ps_LstPerimeters_XRP_Result):void{
      this.suiviAchatsDatas.DivSAPs.push(value.EtbXRP);
      setTimeout(():void=>this.selectedPerimeter = null,0);
  }

  removePerimeter(line:Ps_LstPerimeters_XRP_Result):void {
    if (!this.supplier) return;
    this.suiviAchatsDatas.DivSAPs = this.suiviAchatsDatas.DivSAPs.filter(l=>l!=line.EtbXRP);
  }

  get dateFormatPlaceHolder():any{
    return {
          year: '____', month: '__', day: '__'
        };  
  }
  
  get btnDeposerContratCadreDisabled():boolean {
    if (!this.canUpdateSuiviAchatsPanneauGauche) return true;
    if (!this.selectedContratCadre?.Cod) return true;
    if ((this.selectedContratCadre?.DocId||0)>0) return true;
    return this.supplier?.FrameworkContractDate==null 
    || (this.selectedContratCadre.Description ||'')=='';
  }

  get btnUploadTooltip():string{
    if (this.supplier?.FrameworkContractDate!=null){
      return 'Cliquer_ou_faire_glisser_le_fichier_ici';
    } else {
      return 'La_saisie_de_la_date_est_requise';
    }
  }

  
  controleDateInput (doc:PS_Supplier_Purchase_Docs_Result,promptAlert:boolean = false) : boolean {
    if (!doc) return false;    
    if (doc.TopInputDat==1){
      if (doc.TopDatInputIsEcheance && !doc.DateExpi){
        if (promptAlert) this.sharedDataSvc.pafAlert('Msg_Date_Manquante');
        return false;
      }
      let now = moment();
      if (doc.TopDatInputIsEcheance==1 &&  now.isAfter(doc.DateExpi, "days")) {
        if (promptAlert) this.sharedDataSvc.pafAlert('Msg_Date_Expiration_posterieure');
        return false;
      } 
      if (doc.TopDatInputIsEcheance==0 &&  now.isBefore(doc.DateDoc, "days")) {
        if (promptAlert) this.sharedDataSvc.pafAlert('Msg_Date_Document_anterieure');
        return false;
      }      
    }
    return true;
  }

  public get requiredFileType() : string {
    return this.sharedDataSvc.allowedExtensions.join(',');
  }
  isSizeAllowed(file: File): boolean{
    return file.size<=this.sharedDataSvc.maxFileSize;
  }
  iSExtensionAllowed(filename:string):boolean{
    let ext= ('.'+ filename.split('.')[filename.split('.').length-1]).toUpperCase();
    return this.sharedDataSvc.allowedExtensions.some(e=>e==ext);
  }
  
  private fileIsDropping:boolean = false;
  onFilesContratCadreDropped(event:any):void{
    let files:FileList=<FileList>event;
    const file: File = files[0];
    if (file) {
      if (!this.iSExtensionAllowed(file.name)) {
        this.sharedDataSvc.pafAlert('Extension_non_autorisee');
        this.fileContratCadreUpload.nativeElement.value = "";
          return;
      }
      if (!this.isSizeAllowed(file)) {
          this.sharedDataSvc.pafAlert('Fichier_trop_volumineux');
          this.fileContratCadreUpload.nativeElement.value = "";
          return;
      }
      if ((this.selectedContratCadre.Description||'').trim().length<3){
        this.sharedDataSvc.pafAlert('Precisez_la_description_du_document');
        this.fileContratCadreUpload.nativeElement.value = "";
        return;
      }
      if (!this.controleDateInput(this.selectedContratCadre,true)){
        this.fileContratCadreUpload.nativeElement.value = "";
        return;
      }
      if (this.fileIsDropping) {
        this.sharedDataSvc.pafAlert('Fichier_en_cours_d_import');
        this.fileContratCadreUpload.nativeElement.value = "";
        return;
      }
      this.selectedContratCadre.FullPath = file.name;
      const formData = new FormData();
      //formData.append("regulDocFile", file);
      formData.append(this.selectedContratCadre.Screen, file);
      formData.append("dateInput",this.selectedContratCadre.DateExpi.toDateString());
      formData.append("description",this.selectedContratCadre.Description);
      const upload$ = this.documentsSvc.uploadPurchaseFile(this.selectedContratCadre, formData)
        .pipe(
          finalize(() => {
            this.reset();
            this.fileIsDropping = false;
          })
        );
      this.fileIsDropping = true;
      this.uploadSub = upload$.subscribe(event => {
        if (event.type == HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(100 * (event.loaded / event.total));
        }
      })
    }
  }
  
  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
    this.reloadDocs();
  }

  onFileContratCadreSelected(event: any) {
    this.onFilesContratCadreDropped( event.target.files);
  }

  
  btnDownloadFileClick(): void {
    this.documentsSvc.downloadFile(this.supplier.Id, this.selectedContratCadre?.DocId)
      .subscribe(blob => {
        saveAs(blob, this.getFilename);
      });
  }

  get getFilename(): string {
    if (!this.selectedContratCadre?.FullPath) return '';
    return this.selectedContratCadre?.FullPath.replace(/^.*[\\\/]/, '');
  }
  onDocComChanged(doc:PS_Supplier_Purchase_Docs_Result):void {
    this.reloadDocs();
  }

  onAddComment(commentaire: SupplierPurchaseComment): void {
    if (!commentaire || !commentaire.SupplierId || !commentaire.Comment) {
      return;
    }
    this.sharedDataSvc.WindowLock();
    this.suppliersSvc.addPurchaseComment(commentaire)
      .subscribe({
        next: (res: SimpleReponseResult) => {
          if (!res.Ok) {
            this.sharedDataSvc.alert(res.Message);
          } else {
            this.suppliersSvc.getSupplier(this.supplierId)
              .subscribe(res => {
                this.supplier.SupplierPurchaseComments = res.SupplierPurchaseComments;
                this.initemptyComment();
                //pour rester en mode edition
                this.btnEditModifAchatsClick();
                this.sharedDataSvc.WindowUnlock();
              });
          }
        },
        error: (error: any) => this.sharedDataSvc.alert(error.Message || error)
      });
  }

  onDelComment(commentaire:SupplierPurchaseComment):void {
    if (!commentaire?.Id) {
      return;
    }
    this.sharedDataSvc.WindowLock();
    this.suppliersSvc.delPurchaseComment(commentaire.SupplierId,commentaire.Id)
    .subscribe({
      next:(res:SimpleReponseResult)=>{
        if (!res.Ok){
          this.sharedDataSvc.alert(res.Message);
        } else {
          this.reloadSupplier()
          .subscribe(res=>{
            this.supplier = res;
            //pour rester en mode edition
            this.btnEditModifAchatsClick();
            this.sharedDataSvc.WindowUnlock();
          });
        }
      },
      error:(error:any)=> this.sharedDataSvc.alert(error.Message || error)
    });
  }


  btnEditModifAchatsClick():void {
    this.suiviAchatsBkp = Object.assign({},this.suiviAchatsDatas);

    this.editMode = true;
  }
  btnAnnuleModifAchatsClick():void {
    this.reloadTab().then(()=>{
      this.editMode = false;
    });
  }

  btnValidModifAchatsClick(frmToCheck:NgForm):void {
     if (this.sharedDataSvc.formRevealErrors(frmToCheck,true)){
      return;
     }
     this.sharedDataSvc.WindowLock();
     this.suppliersSvc.UpdateSuiviAchats(this.supplierId,this.suiviAchatsDatas)
     .subscribe((res:SimpleReponseResult)=>{
       if (!res.Ok) {
         this.sharedDataSvc.alert(res.Message);
       } else {
        this.reloadSupplier()
        .subscribe(res=>{
          this.supplier = res;
          this.sharedDataSvc.WindowUnlock();
        });
       }
     })
  }

  get canUpdateSuiviAchatsPanneauGauche():boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('canUpdateSuiviAchatsPanneauGauche');
  }

  get canViewContratCadre():boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('canViewContratCadre');
  }
  get canUpdateContratCadre():boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('canViewContratCadre') && this.editMode && this.uploadProgress == null;
    //return ['ADMIN','ACH_FAMHA','CTRL_QUAL'].indexOf(this.sharedDataSvc.profil?.Cod)>=0 && this.editMode && this.uploadProgress == null;
  }

  get canAddDocCommercial():boolean {
    if (!this.editMode) return false;
    return this.sharedDataSvc.checkProfilAccessPafSettings('canAddDocCommercial');
    //return ['ADMIN','ACH_OPERAT','ACH_OPERAT_2','ACH_FAMHA','CTRL_QUAL'].indexOf(this.sharedDataSvc.profil?.Cod)>=0;
  }
  
  get canAddDocCommentaire() {
    if (!this.editMode) return false;    
    return this.sharedDataSvc.checkProfilAccessPafSettings('canAddDocCommentaire');
    //return ['ADMIN','ACH_OPERAT','ACH_OPERAT_2','ACH_FAMHA','CTRL_QUAL'].indexOf(this.sharedDataSvc?.profil?.Cod)>=0;
  }

  
  get canViewFilesAndComments() {       
    return this.sharedDataSvc.checkProfilAccessPafSettings('canViewFilesAndComments');
    //return ['ADMIN','ACH_OPERAT','ACH_OPERAT_2','ACH_FAMHA','CTRL_QUAL'].indexOf(this.sharedDataSvc?.profil?.Cod)>=0;
  }

  get btnValidModifAchatsDisabled():boolean {
    return !this.frmSuiviAchats?.dirty;
  }

  get showEditButton(): boolean{
    return this.sharedDataSvc.checkProfilAccessPafSettings('SuiviAchatsShowEditButton');
    //return ['ADMIN','ACH_OPERAT','ACH_OPERAT_2','ACH_FAMHA','CTRL_QUAL'].indexOf(this.sharedDataSvc.profil?.Cod)>=0;
  }
  
  
  get getContratCadreFilename(): string {
    if (this.selectedContratCadre==null) return '';
    if (!this.selectedContratCadre?.FullPath) return '';
    return this.selectedContratCadre.FullPath.replace(/^.*[\\\/]/, '');
  }

  ContratsCadreTypeChange(event:Event) {
    if (!this.suiviAchatsDatas.FrameworkContractPafDocId){
      this.suiviAchatsDatas.FrameworkContractDate = null;
    }
  }

  get selectedPerimeterRequired():boolean {
    return this.selectedPerimeters.length==0;
  }

  get contratCadreRequired():boolean {
    return !!this.suiviAchatsDatas.FrameworkContractPafDocId && !this.lstContratsCadreForCods.some(d=>d.DocId>0);
  }

  /**
   * Ajoute tous les établissements sélectionnables par l'utilisateur et non sélectionnés
   */
  addAllPerimeters():void{
    this.unselectedPerimeters.filter(p=> !this.IsEtbReadOnly({dataItem:p})).forEach(p=> this.suiviAchatsDatas.DivSAPs.push(p.EtbXRP));
  }
  /**
   * Supprime tous les établissements sélectionnés et sélectionnables par l'utilisateur
   */
  deleteAllPerimeters():void{
    this.suiviAchatsDatas.DivSAPs = this.suiviAchatsDatas.DivSAPs.filter(etb=> !this.userDrs.some(p=>p.EtbXRP==etb));
  }

  public IsEtbReadOnly = (item:any):boolean => {
    let etbXRP: Ps_LstPerimeters_XRP_Result = item.dataItem;
    if (!etbXRP) return true;
    return !this.userDrs.some(p=>p.EtbXRP==etbXRP.EtbXRP && p.SocXRP==etbXRP.SocXRP);
  };

}
